import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';

/**
 * 定义 Header 组件
 */
class HeaderLogo extends React.PureComponent {
    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.logoBox}>
                <img src={content[0].logoImg} className={styles.logoImg} />
                <img src={content[0].MottoImg} className={styles.MottoImg} />
            </div>
        );
    }
}

/**
 * 定义组件属性类型
 * */
HeaderLogo.propTypes = { content: PropTypes.array };

/**
 * 定义组件默认属性
 * */
HeaderLogo.defaultProps = {};

export { HeaderLogo };
export default HeaderLogo;
